import permissions from '../../permissions'

const CHANGES_MANAGEMENT_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.CHANGES_MANAGEMENT.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.CHANGES_MANAGEMENT.MANAGE,
  },
]

export default CHANGES_MANAGEMENT_LIST
